import { render, staticRenderFns } from "./ItemTagsModal.vue?vue&type=template&id=1c154bdf&scoped=true&"
import script from "./ItemTagsModal.vue?vue&type=script&lang=js&"
export * from "./ItemTagsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c154bdf",
  null
  
)

export default component.exports